import { createContext } from 'react';
const LocaleContext = /*#__PURE__*/createContext(undefined);
export default LocaleContext;